import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PieChart, Pie, Cell, Legend, ResponsiveContainer } from 'recharts';

const TestResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { answers, questions } = location.state || {};

  const [sectionWiseMarks, setSectionWiseMarks] = useState({});
  const [overallPercentage, setOverallPercentage] = useState(0);

  useEffect(() => {
    if (questions && answers) {
      const totalQuestions = questions.length;
      let totalCorrect = 0;
      const sectionMarks = {};

      questions.forEach((question, index) => {
        const section = question.section || 'General';
        if (!sectionMarks[section]) sectionMarks[section] = { total: 0, correct: 0 };

        sectionMarks[section].total++;
        if (answers[index] === question.correctAnswer) {
          sectionMarks[section].correct++;
          totalCorrect++;
        }
      });

      const percentage = ((totalCorrect / totalQuestions) * 100).toFixed(2);
      setOverallPercentage(percentage);
      setSectionWiseMarks(sectionMarks);
    }
  }, [questions, answers]);

  const handleBackToDashboard = () => {
    navigate('/studentmark-dashboard');
  };

  // Pie chart data
  const pieData = [
    { name: 'Correct Answers', value: overallPercentage },
    { name: 'Incorrect Answers', value: 100 - overallPercentage },
  ];

  return (
    <div style={{ padding: '2rem', backgroundColor: '#f4f7fa', borderRadius: '8px' }}>
      <h2 style={{ textAlign: 'center', color: '#3e4c59' }}>Test Results</h2>
      <h3 style={{ textAlign: 'center', color: '#4CAF50' }}>Overall Percentage: {overallPercentage}%</h3>

      {/* Pie Chart */}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
        <ResponsiveContainer width="50%" height={300}>
          <PieChart>
            <Pie
              data={pieData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius="40%"
              outerRadius="60%"
              fill="#82ca9d"
              paddingAngle={5}
              label
            >
              <Cell key="1" fill="#4CAF50" />
              <Cell key="2" fill="#FF6347" />
            </Pie>
            <Legend iconType="circle" layout="horizontal" align="center" />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Section-wise Marks */}
      <div>
        <h3 style={{ color: '#1976D2' }}>Section-wise Marks:</h3>
        {Object.keys(sectionWiseMarks).map((section) => (
          <div key={section} style={{ marginBottom: '1rem', backgroundColor: '#e1f5fe', padding: '10px', borderRadius: '8px' }}>
            <h4 style={{ color: '#1565C0' }}>{section}:</h4>
            <p>Correct: {sectionWiseMarks[section].correct} / {sectionWiseMarks[section].total}</p>
          </div>
        ))}
      </div>

      {/* Question-wise Review */}
      <div style={{ marginTop: '2rem' }}>
        <h3 style={{ color: '#FF5722' }}>Question-wise Review:</h3>
        {questions.map((question, index) => (
          <div
            key={index}
            style={{
              borderBottom: '1px solid #ccc',
              marginBottom: '1rem',
              paddingBottom: '1rem',
              backgroundColor: '#fff3e0',
              borderRadius: '8px',
              padding: '10px',
            }}
          >
            <p><strong>Q{index + 1}: {question.questionText}</strong></p>
            <p>Your Answer: <span style={{ color: answers[index] === question.correctAnswer ? '#4CAF50' : '#FF6347' }}>{answers[index] || 'Not Answered'}</span></p>
            <p>Correct Answer: {question.correctAnswer}</p>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <button onClick={handleBackToDashboard} style={{ padding: '0.5rem 1rem', backgroundColor: '#1976D2', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default TestResultPage;
